<template>
  <div class="skip-navigation">
    <a 
      href="#main-content" 
      class="skip-link"
      @click="skipToMain"
      ref="skipLink">
      {{ $t('accessibility.skipToMainContent') }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'SkipNavigation',
  methods: {
    skipToMain(event) {
      event.preventDefault();
      const mainContent = document.getElementById('main-content');
      if (mainContent) {
        mainContent.setAttribute('tabindex', '-1');
        mainContent.focus();
        mainContent.addEventListener('blur', () => {
          mainContent.removeAttribute('tabindex');
        }, { once: true });
      }
    }
  }
};
</script>

<style scoped>
.skip-navigation {
  position: relative;
}

.skip-link {
  position: absolute;
  top: -100px;
  left: 0;
  background-color: #000;
  color: #fff;
  padding: 12px 16px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  z-index: 10000;
  border-radius: 0 0 4px 0;
  transition: top 0.2s ease-in-out;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.skip-link:focus {
  top: 0;
  outline: 3px solid #4CAF50;
  outline-offset: 2px;
}

.skip-link:hover {
  background-color: #333;
}

.skip-link:active {
  background-color: #555;
}
</style>
